import React, { useEffect, useRef, useState } from "react";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import Teaxtarea from "../../../components/elements/form/textarea";
import Button from "../../../components/elements/button";
import toast from "react-hot-toast";
import { useWorkOrderApi } from "../../../store/api/hooks/workOrderApiHook";
import Loader from "../../../components/loader";
import { useWorkRequestApi } from "../../../store/api/hooks/workRequestApiHook";
import { cancel } from "redux-saga/effects";

interface CancelWRprops {
  _ref?: any;
  editData?: any;
  currentStatus?:any;
  onCreate?: () => void;
  onCancel?: () => void;
}

const CancelWorkRequestSidebar: React.FC<CancelWRprops> = ({ _ref, editData, currentStatus, onCreate = () => {}, onCancel = () => {} }) => {
  const { control, handleSubmit, setValue, reset, formState: { errors }, watch, getValues } = useForm<any>({
    defaultValues: {    
        workRequestNote: ``
    }
  });  

  const hasEditRun = useRef(false);
  const workRequestApi: any = useWorkRequestApi();

  const [ woloader, setWoloader ] = useState<boolean>(false);
  

  const onSubmit: SubmitHandler<any> = async (data: any) => {
    console.log("data is -> ", data);
    if (editData && editData?.workRequestID) {
        setWoloader(true);
        const noteresp:any = await new Promise((resolve, reject) => {
            workRequestApi.SaveWorkRequestNotes({
                objRequestModel: [{
                    workRequestNoteID: null,
                    workRequestID: editData?.workRequestID,
                    workRequestNote: data?.workRequestNote
                }]
            }, (resp: any) => {
                resolve(resp);            
            }, (err: any) => {
                reject(err);
            });
        }).catch(err => {
            return err
        });
        if (noteresp && noteresp.hasOwnProperty(`code`) && noteresp.hasOwnProperty(`successful`) && noteresp.code === 200 && noteresp.successful == true) {
            const cancelresp:any = await new Promise((resolve, reject) => {
                workRequestApi.MoveStatus({
                    workRequestID: editData?.workRequestID,
                    statusID: currentStatus
                }, (resp: any) => {
                    resolve(resp);
                }, (err: any) => {
                    reject(err);
                });
            }).catch(err => {
                return err
            });
            if (cancelresp && cancelresp.hasOwnProperty(`code`) && cancelresp.hasOwnProperty(`successful`) && cancelresp.code === 200 && cancelresp.successful == true) {
                toast.success(cancelresp?.message || `Work request cancelled successfully!`);
                hasEditRun.current = false;
                onCreate();
            } else {
                toast.error(cancelresp?.message || `Unable to cancel work request due to unhandled api response!`);                
            }
        } else {
            toast.error(noteresp?.message || `Unable to save cancellation note due to unhandled api response!`);
        }  
        setWoloader(false); 
    } else {
        toast.error(`Work request data is not available!`);                
    }
  };

   useEffect(() => {
      
    }, []);  
  
    useEffect(() => {
      if (editData && !hasEditRun.current) {
          console.log("editData", editData);      
          hasEditRun.current = true;        
      }
    }, [ editData ]);

  useEffect(() => {
    if (_ref?.current) {      
    }
  }, [_ref]);

  return (
    <div>
      {woloader && (
        <div className={ `absolute p-8` } style={{ height: "100%", width: "100%", zIndex: 2, backgroundColor: "rgba(255, 255, 255, 0.5)" }}>
          <Loader />
        </div>
      )}
      <form onSubmit={handleSubmit(onSubmit)} ref={_ref} className={ `${woloader? `hidden`: `flex`} flex-col` }>
        <div className="flex-1 overflow-auto" style={{ minHeight: `calc(100vh - 152px)` }}>
            <Controller
              name="workRequestNote"
              rules={{ required: "Cancellation Note is required" }}
              control={control}
              render={({ field: { value, onChange } }) => (
                <Teaxtarea
                  label="Cancellation Note"
                  value={value}
                  onChange={onChange}
                  required
                  placeholder="Cancellation Note"
                  error={errors.workRequestNote?.message as any}
                />
              )}
            />            
        </div>

        <div className="flex justify-end gap-2 flex-shrink-0 pt-5 pb-1 border-t" style={{ borderTopColor: `#50575B` }}>
          <Button type="submit" customstyle={{ background: `#2D6A32`, width: 142, height: 40 }} childstyle={{ justifyContent: `center`, fontSize: 15 }}>Save</Button>
          <Button type="button" theme="secondary" onClick={() => {
              hasEditRun.current = false;
              onCancel();
            }}
            customstyle={{ width: 97, height: 40 }} childstyle={{ justifyContent: `center`, fontSize: 15 }}
          >
            Cancel
          </Button>        
        </div>
      </form>
    </div>
  );
}

export default CancelWorkRequestSidebar;